/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {}

// 领域查询
exports.getUnivBizDomnList = function (params, callback) {
    api.get('/projcomn/univBizDomn/list')
        .sync(true)
        .params(params)
        .done(callback)
        .go()
}

// 项目类型查询
exports.getProjTypeList = function (params, callback) {
    api.get('/projcomn/projType/list')
        .sync(true)
        .params(params)
        .done(callback)
        .go()
}

// 条目类型查询
exports.getUnivItemTypeList = function (params, callback) {
    api.get('/projcomn/univItemType/list')
        .sync(true)
        .params(params)
        .done(callback)
        .go()
}



export default exports



//////////////////
// WEBPACK FOOTER
// ./src/api/projComn.js
// module id = 2004
// module chunks = 0